<card>
  <div class="title--section" title>
    @if (!success && errorMessage) {
      <div class="error--section">
        @for (error of errorMessage; track error) {
          <p
            class="t-bold t-error u-flex u-justifyCenter"
            data-test-id="authCardErrorMessage"
          >
            {{ error }}
          </p>
        }
      </div>
    }

    <div class="titles--section">
      <h1
        class="ui-title"
        data-test-id="authCardTitle"
        [innerHTML]="
          success && config?.successTitle ? config?.successTitle : config?.title
        "
      ></h1>

      <p
        class="t-data"
        [innerHTML]="
          success && config?.successSubtitle
            ? config?.successSubtitle
            : config?.subtitle
        "
        data-test-id="authCardSubtitle"
      ></p>
    </div>
  </div>

  <div class="body--section" body>
    <div class="body--content">
      <form-group
        class="body-select-name"
        (linkClicked)="linkClicked.emit($event.config)"
        (formCreated)="patchDOB()"
        [configs]="config?.form?.controls"
        [form]="formGroup"
        data-test-id="authCardContent"
      ></form-group>
    </div>

    @if (browserSupportConfig?.showBanner && !isBrowserSupported) {
      <message-banner
        [config]="browserSupportConfig.banner"
        data-test-id="authCardMessageBanner"
      >
      </message-banner>
    }

    <div class="body--footer">
      @if (config?.footer?.link) {
        <p
          class="t-data t-link"
          (click)="linkClicked.emit(config?.footer?.link)"
          [innerHTML]="config?.footer?.link?.label"
          data-test-id="authCardfooterLink"
        ></p>
      }

      <zip-button
        data-test-id="logIn"
        (zipButtonClicked)="buttonClicked.emit()"
        [content]="config?.footer?.button?.content"
        [disabled]="disableButton || !formGroup.valid"
        [icon]="config?.footer?.button?.icon"
        [level]="config?.footer?.button?.level"
      >
      </zip-button>
    </div>
  </div>
</card>
